var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-info-page .form-content .el-form-item__label{padding-right:34px;font-size:16px}.app-info-page .form-content .el-form-item__content{font-size:16px;color:#666}.app-info-page .upload-box{display:inline-block;width:80px;height:80px;vertical-align:middle}.app-info-page .upload-box .el-upload{width:80px;height:80px;background:url(" + escape(require("../../../assets/img/control/icon_upload.png")) + ");background-size:100% 100%}.app-info-page .upload-box .app-upload-img{width:100%;height:100%;vertical-align:top}.app-info-page .upload-tips{display:inline-block;margin-left:7px;color:#9e9e9e;font-size:12px;line-height:16px;position:relative;top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91d9ab3a","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/control/app/info.vue
// module id = 856
// module chunks = 0